export default {
  props: {
    phase: {
      type: Number,
      default: 1,
    },
  },
  created() {
    this.$emit('phase-change', this.phase);
  },
};



// WEBPACK FOOTER //
// ./src/views/composition/common/mixin.js